import * as React from "react";
import { TextInputEditor } from "../internal/text-input-editor";

export type TextValue = string | null;

export function TextEditor({
  value,
  onCommit,
  onCancel,
}: {
  value: TextValue;
  onCommit: (next: TextValue) => void;
  onCancel: () => void;
}) {
  const parse = React.useCallback(
    (draft: string) => ({ ok: true as const, value: draft === "" ? null : draft }),
    [],
  );
  return (
    <TextInputEditor<TextValue>
      initial={value ?? ""}
      parse={parse}
      onCommit={onCommit}
      onCancel={onCancel}
      inputType="text"
    />
  );
}
